import { useEffect, useState } from 'react'

import './App.scss'
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import LoadingPage from './pages/loading/loading-page.page'
import Register from './pages/sign-in/register.component';
import ProfilePage from './pages/profile/profile.page';
import LandingPage from './pages/landing-page/landing-page.comp';
import SignIn from './pages/sign-in/sign-in.component';
import LogoutPage from './pages/logout/logout-page.page';
import PageNotFound from './pages/page-not-found/page-not-found.component';
import { auth } from './utils/firebase.utils';
import { onAuthStateChanged } from 'firebase/auth';
import { setCurrentUser } from './state/slices/userSlice';
import HomePage from './pages/home-page/home-page.page';
import AdminPage from './pages/admin/admin.page';
import LeaguesPage from './pages/leagues/leagues-page.page';
import HowItWorksPage from './pages/how-it-works/how-it-works.page';

function App() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentUser = useSelector(state => state.userData.currentUser)
    const userProfile = useSelector(state => state.userData.userProfile)

    useEffect(() => {
        signInUser();
        
    }, [])
    
    function signInUser() {
        const href = window.location.href
        const currentlySignedInUser = auth.currentUser;
        if (currentlySignedInUser) {
            saveUserToState(currentlySignedInUser)
        }
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                // console.log(user)
                saveUserToState(user)
                if (href.includes('/signin')) {
                    navigate('/loading') 
                }
                // navigate('/loading')  
            } else {
                if (currentUser) {
                    navigate('/logout')
                }
                if (!href.includes('/signin') && !href.includes('/register') && !href.includes('/info') && !href.includes('/how-it-works')) {
                    navigate('/')
                }
            }
        });
    }

    function saveUserToState(user) {
        const newUser = {
            displayName: user.displayName,
            email: user.email,
            metadata: {
                createdAt: Number(user.metadata.createdAt),
                lastLogInAt: user.metadata.lastLogInAt
            },
            uid: user.uid,
            photoURL: user.photoURL,
            provider: user.providerData[0].providerId
        }
        dispatch(setCurrentUser({...newUser}));
    }

    return (
        <div>
            <Routes>
                <Route path='' element={<LandingPage />}></Route>
                <Route path='/home/*' element={<HomePage />}></Route>
                <Route path='/leagues/*' element={<LeaguesPage />}></Route>
                <Route path='/signin' element={<SignIn />}></Route>
                <Route path='/register' element={<Register />}></Route>
                <Route path='/logout' element={<LogoutPage />}></Route>
                <Route path='/loading/*' element={<LoadingPage />}></Route>
                <Route path='/loading/:refreshProfile' element={<LoadingPage />}></Route>
                <Route path='/profile' element={<ProfilePage />}></Route>
                <Route path='/admin/*' element={<AdminPage />}></Route>
                <Route path='/how-it-works' element={<HowItWorksPage />}></Route>
                
                <Route path='/404' element={<PageNotFound />}></Route>
                <Route path="*" element={<Navigate replace to="/404" />} />
                <Route path="/noaccess" element={<Navigate replace to="/404" />} />
            </Routes>
        
        </div>
    );
}

export default App
